import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { BookChapter } from "@/components/BookChapter";
import { AdStudio } from "@/components/AdStudio";
import { Publisher } from "@/components/Publisher";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { BOOKS } from "@/data/books";

function App() {
  useLenis();

  useEffect(() => {
    document.title = "Samkhya Publishing — Stories That Wake the Mind";
  }, []);

  return (
    <div className="App bg-[#0C0A09] font-sans text-[#F4F4F0] antialiased">
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        {BOOKS.map((book, i) => (
          <BookChapter key={book.id} book={book} flip={i % 2 === 1} />
        ))}
        <AdStudio />
        <Publisher />
        <ContactSection />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
